import api from 'ApiConfig';

const attendanceService = {
  getAttendanceReport: async (date) => {
    return api.post('/student/get-attendance', {
      date,
    });
  },
  getMonthlyAttendance: async (month, year) => {
    return api.post('/student/get-monthly-attendance', {
      month,
      year,
    });
  },
};

export default attendanceService;
